import React, { FC, ReactElement } from 'react';
import cx from 'clsx';
import errorIcon from 'images/icons/error-exclaimation.svg';
import successIcon from 'images/icons/success-banner-check.svg';
import styles from './SproutBanner.module.scss';
import { Image } from 'components/Image/Image';

export type SproutErrorBannerVariant = 'error' | 'success';

export interface IBannerProps {
  bannerText: string | ReactElement;
  variant: SproutErrorBannerVariant;
}

export const SproutBanner: FC<IBannerProps> = ({ bannerText, variant }) => {
  const imagePath = variantIcon[variant];
  return (
    <section className={styles.bannerSection}>
      <div className={cx(styles.banner, styles[variant])} role="alert">
        <span className={styles.glyph}>
          <Image src={imagePath} aria-hidden />
        </span>
        <p className={styles.content}>{bannerText}</p>
      </div>
    </section>
  );
};

export const variantIcon: Record<SproutErrorBannerVariant, string> = {
  ['error']: errorIcon,
  ['success']: successIcon,
};
